export const safeDivide = (num, denom) => {
    if (denom === 0) {
        return 0;
    }

    return num / denom;
};
